import { atom } from 'jotai';

const lzSCommonsLoadingAtom = atom<boolean>(false);

export default lzSCommonsLoadingAtom;
